import { NumberField } from "@justhome/react-ui";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useController } from "react-hook-form";
import useFormStep from "../../lib/useFormStep";
import FormStep from "../FormStep";

const PurchasePriceStep: FC = () => {
  const { t } = useTranslation();
  const { form, handleSubmit, handleBack } = useFormStep({
    next: "equity",
  });

  const {
    control,
    formState: { errors },
  } = form;

  const { field } = useController({
    name: "purchasePrice",
    control,
    rules: {
      required: {
        value: true,
        message: t("purchasePrice.required"),
      },
    },
  });

  return (
    <FormStep
      onBack={handleBack}
      onSubmit={handleSubmit}
      title={t("purchasePrice.title")}
      description={t("purchasePrice.description")}
    >
      <NumberField
        {...field}
        autoFocus
        label={t("purchasePrice.label")}
        placeholder={t("purchasePrice.placeholder")}
        suffix="€"
        errorMessage={errors.purchasePrice?.message}
        data-testid="purchasePrice"
      />
    </FormStep>
  );
};

export default PurchasePriceStep;
